import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import PropertyCardContext from '../../PropertyCardContext';
import { BadgeContainer } from './BadgeSection.style';
const BadgeSection = ({ children }) => {
    const { isCardSelected } = useContext(PropertyCardContext);
    return (_jsx(BadgeContainer, { isCardSelected: isCardSelected, children: children }));
};
export default BadgeSection;
